import { useState } from 'react';
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import { trackRender } from '../utils/debugRender';

export default function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // 🔍 DEBUG: Track renders to identify infinite loops
  trackRender('Layout', { sidebarOpen });

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      {/* Content area */}
      <div className="relative flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
        {/* Header */}
        <Header sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

        {/* Main content */}
        <main className="grow">
          <div className="mx-auto max-w-screen-2xl p-4 md:p-6 2xl:p-10">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
